import { useRef } from 'react'
import {
  DO_NOT_TRACK,
  addAdobeAnalytics,
  addFbPixelTracking,
  addGtag,
  addGoogleTagManager,
  addOneTrustScript,
  addSegmentTracking,
  addTikTokTracking,
  addTwitterTracking,
  addAdrollAnalytics,
  addTealiumAnalytics,
} from './configureTrackers'

interface TrackingParams {
  suppressSrDiningAnalytics?: boolean
  srGoogleTagsId?: string
  googleTagManagerId?: string
  googleTagId?: string
  adobeId?: string
  fbPixelIdFromInstagram?: string
  fbPixelIdsAll?: string[]
  tikTokId?: string
  oneTrustId?: string
  twitterId?: string
  segmentId?: string
  adrollAdvId?: string
  adrollPixId?: string
  tealiumAccount?: string
  tealiumProfile?: string
}

interface UseTrackersProps {
  params?: TrackingParams
  ready: boolean
}

export function useTrackers({ params, ready }: UseTrackersProps) {
  const isTrackersSet = useRef(false)
  if (!isTrackersSet.current && params && ready) {
    isTrackersSet.current = true
    const {
      adobeId,
      fbPixelIdsAll,
      googleTagId,
      googleTagManagerId,
      oneTrustId,
      segmentId,
      srGoogleTagsId,
      suppressSrDiningAnalytics,
      tikTokId,
      twitterId,
      adrollAdvId,
      adrollPixId,
      tealiumAccount,
      tealiumProfile,
    } = params
    if (oneTrustId) {
      addOneTrustScript(oneTrustId)
    }
    if (DO_NOT_TRACK) {
      return
    }
    if (adobeId) {
      addAdobeAnalytics(adobeId)
    }
    if (fbPixelIdsAll) {
      addFbPixelTracking(fbPixelIdsAll)
    }
    if (googleTagId) {
      addGtag(googleTagId)
    }
    if (googleTagManagerId) {
      addGoogleTagManager(googleTagManagerId)
    }
    if (segmentId) {
      addSegmentTracking(segmentId)
    }
    if (srGoogleTagsId && !suppressSrDiningAnalytics) {
      addGoogleTagManager(srGoogleTagsId)
    }
    if (tikTokId) {
      addTikTokTracking(tikTokId)
    }
    if (twitterId) {
      addTwitterTracking(twitterId)
    }

    if (tealiumAccount && tealiumProfile) {
      addTealiumAnalytics(tealiumAccount, tealiumProfile)
    }

    if (adrollAdvId && adrollPixId) {
      addAdrollAnalytics(adrollAdvId, adrollPixId)
    }
  }
}
